import { clsx } from "clsx";
import { type FC, type JSX, useState } from "react";
import { Tag, TagIntent, TriggerButton, TriggerButtonSize, VStack } from "widgets";

import styleSkeleton from "../styles/loading-skeleton.module.scss";
import { type INavPanelCategory } from "./NavigationPanel.js";
import { RouteNavItem } from "./RouteNavItem.js";
import style from "./styles/NavigationCategory.module.scss";

interface INavigationCategoryProps {
  navCategory: INavPanelCategory;
  notCollapsible?: boolean;
  isLoading?: boolean;
}

export default function NavigationCategory({
  navCategory,
  notCollapsible,
  isLoading,
}: INavigationCategoryProps): JSX.Element {
  const [isCollapsed, setCollapsed] = useState<boolean>(false);
  const items = navCategory.navItems || [];

  const CollapseButton: FC = () =>
    !(notCollapsible === true) ? (
      <TriggerButton
        onPress={() => setCollapsed(!isCollapsed)}
        icon={isCollapsed ? "keyboard_arrow_down" : "keyboard_arrow_up"}
        label={""}
        aria-label={isCollapsed ? "Expand" : "Collapse"}
        className={style.header_button}
        size={TriggerButtonSize.Small}
      />
    ) : null;

  return (
    <div className={style.category}>
      <div className={style.header}>
        <div className={clsx(style.title, { [style.title_no_badge]: !navCategory.badge })}>
          <span>
            {isLoading ? <span className={styleSkeleton.skeleton}>Lorem ipsum dolor</span> : navCategory.label || null}
          </span>
          {navCategory.badge && <Tag label={navCategory.badge} intentColor={TagIntent.Outlined} />}
          {!navCategory.badge && <CollapseButton />}
        </div>
      </div>
      {navCategory.widget && <div className={style.list}>{navCategory.widget}</div>}
      {!isCollapsed && items.length > 0 && (
        <VStack spacing={1} className={style.list}>
          {items.map((navItem) => {
            return <RouteNavItem {...navItem} key={`nav-item-${navItem.route}`} isLoading={isLoading} />;
          })}
        </VStack>
      )}
    </div>
  );
}
